<template>
  <div class="Index" id="captchaBox"></div>
</template>

<script>
import axios from "axios";
import "./gt.js";
import {get} from 'api/request';
import qs from "qs";
import urls from "../../api/goods-list/apilist";
let host = "http://114.55.84.73:80";//正式服
let register = "/shopweb-support/gt/register";
let sendValidateCode = "/wdsx-shop/sms/sendMobileCode";

export default {
  props: {
    options: {
      type: Object,
      default() {
        return {
          product: "bind"
        };
      }
    },
    phone: {
      type: String,
      default: ""
    },
    pageCode: {
      type: String,
      default: "111"
    },
    valCode: {
      type: String,
      default: "111"
    }
  },
  data() {
    return {
      captchaObj: null,
      params: {}
    };
  },
  created() {
    this.register();
  },
  methods: {
    /**
     * 验证初始化
     */
    initGeetest(data) {
      let params = Object.assign(
        {},
        {
          gt: data.gt,
          challenge: data.challenge,
          offline: !data.success,
          new_captcha: true
        },
        this.options
      );

      return new Promise((r, j) => {
        initGeetest(params, captchaObj => {
          this.captchaObj = captchaObj;
          r(captchaObj);
        });
      });
    },

    /**
     * 验证成功
     */
    validateSuccess() {
      let {
        challenge,
        geetest_challenge,
        geetest_validate,
        geetest_seccode
      } = this.params;

      let { phone, pageCode, valCode } = this;

      if (this.phone) {
        let params = {
          /*challenge: challenge,
          secchallenge: geetest_challenge,
          secvalidate: geetest_validate,
          seccode: geetest_seccode,
          phoneNumber: phone,
          pageCode: pageCode,
          valCode: valCode,*/
          type: 2,//1是万店掌模板，2是万店上选
          mobilePhone:phone
        };

        this.sendValidateCode(params)
          .then(res => {
            console.log("TCL: validateSuccess -> res", res);
            // 验证码发送成功
            this.$emit("send-code-success", res);
          })
          .catch(err => {
            // 验证码发送失败
            console.log("TCL: validateSuccess -> err", err);
            this.$emit("send-code-error", err);
          });
      }
    },

    /**
     * 验证初始及处理
     */
    register(params = {}) {
      return axios
        .get(host + register, { t: +new Date().getTime() })
        .then(res => {
          let data = res.data;
          this.params = data;
          // 初始化极验
          this.initGeetest(data).then(captchaObj => {
            captchaObj.appendTo("#captchaBox");
            // 初始化成功后绑定事件
            captchaObj
              .onReady(() => {
                // 行为验证准备
                this.$emit("ready", { captchaObj, params: this.params });
              })
              .onSuccess(() => {
                var result = captchaObj.getValidate();
                Object.assign(this.params, result);
                this.phone && this.validateSuccess();
                // 行为验证成功
                this.$emit("success", Error);
              })
              .onClose(() => {
                // 关闭行为验证弹窗
                this.$emit("close", { captchaObj, params: this.params });
              })
              .onError(function(error) {
                console.log("TCL: register -> error", error);
                // 行为验证失败
                this.$emit("error", error);
              });
          });
        });
    },

    /**
     * @public
     * 显示验证
     */

    verify() {
      this.captchaObj && this.captchaObj.verify();
    },

    /**
     *  @public
     * 复位
     */
    reset() {
      this.captchaObj && this.captchaObj.reset();
    },

    /**
     * @public
     * 销毁
     */
    destroy() {
      this.captchaObj && this.captchaObj.destroy();
    },

    /**
     * 发送验证码
     */
    sendValidateCode(params = {}) {
      return get(sendValidateCode, params)
      /*return axios
        .get(sendValidateCode, {params})
        .then(res => {
          return res.data || null;
        });*/
    }
  }
};
</script>

<style scoped lang="scss"></style>
